import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import { API_BASE_URL } from "../../../const";
import ScreenCaption from '../../screen-caption.js';
import del from '../../../img/del.svg';

export default class EventGalleryScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args;

        this.state = {
            args: args,
            eventid: args.eventid,
            event: args.event,
            photos: [],
            selectedPhoto: null,
            loading: false,
            uploading: false,
            error: null,
            dragOver: false
        };

        this.fileInputRef = React.createRef();

        this.loadPhotos = this.loadPhotos.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.handleFileInput = this.handleFileInput.bind(this);
        this.openFileDialog = this.openFileDialog.bind(this);
        this.deletePhoto = this.deletePhoto.bind(this);
        this.downloadAllPhotos = this.downloadAllPhotos.bind(this);
        this.createMobileUploadLink = this.createMobileUploadLink.bind(this);

    }

    componentDidMount() {
        this.loadPhotos();
    }

    authHeaders() {
        return {
            'SESSIONID': sessionStorage.getItem("session")
        };
    }

    async loadPhotos() {
        if (!this.state.eventid) {
            this.setState({ error: "Не задано событие" });
            return;
        }

        this.setState({ loading: true, error: null });

        BaseApi.get("/event/photos", {
            headers: this.authHeaders(),
            params: { eventid: this.state.eventid },
            withCredentials: true
        })
        .then(res => {
            const photos = res.data || [];
            this.setState({
                photos: photos,
                selectedPhoto: photos.length > 0 ? photos[0] : null,
                loading: false
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({
                loading: false,
                error: "Не удалось загрузить фотографии"
            });
        });
    }

    handleFileInput(event) {
        this.handleFiles(event.target.files);
        event.target.value = "";
    }

   async handleFiles(fileList) {
        const files = Array.from(fileList || []);

        console.log(`CAV ${files.length}`)

        const imageFiles = files.filter(file =>
            file.type === "image/jpeg" || file.type === "image/jpg"
        );

        if (imageFiles.length === 0) {
            this.setState({ error: "Можно загрузить только JPEG-фотографии" });
            return;
        }

        this.setState({ uploading: true, error: null });

        try {
            const resizedFiles = [];

            for (const file of imageFiles) {
                const resized = await this.resizeJpegFile(file, 1800, 0.82);
                resizedFiles.push(resized);
            }

            const formData = new FormData();
            formData.append("eventid", this.state.eventid);

            resizedFiles.forEach(file => {
                formData.append("files[]", file);
            });

            await BaseApi.post("/event/photos", formData, {
                headers: {
                    ...this.authHeaders()
                },
                withCredentials: true
            });

            this.setState({ uploading: false });
            this.loadPhotos();

        } catch (error) {
            console.log(error);
            this.setState({
                uploading: false,
                error: "Не удалось подготовить или загрузить фотографии"
            });
        }
    }

    openFileDialog() {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    }

    async resizeJpegFile(file, maxSide = 1800, quality = 0.82) {
        if (!["image/jpeg", "image/jpg"].includes(file.type)) {
            throw new Error("Можно загрузить только JPEG");
        }

        const imageUrl = URL.createObjectURL(file);

        try {
            const img = await new Promise((resolve, reject) => {
                const image = new Image();
                image.onload = () => resolve(image);
                image.onerror = reject;
                image.src = imageUrl;
            });

            const scale = Math.min(
                maxSide / img.width,
                maxSide / img.height,
                1
            );

            const width = Math.round(img.width * scale);
            const height = Math.round(img.height * scale);

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            const blob = await new Promise((resolve, reject) => {
                canvas.toBlob(
                    result => result ? resolve(result) : reject(new Error("Ошибка сжатия изображения")),
                    "image/jpeg",
                    quality
                );
            });

            return new File(
                [blob],
                file.name.replace(/\.[^.]+$/, ".jpg"),
                { type: "image/jpeg" }
            );
        } finally {
            URL.revokeObjectURL(imageUrl);
        }
    }



    deletePhoto(photo) {
        if (!photo || !photo.id) {
            return;
        }

        BaseApi.delete("/event/photos", {
            headers: this.authHeaders(),
            params: { id: photo.id },
            withCredentials: true
        })
        .then(() => {
            const photos = this.state.photos.filter(p => p.id !== photo.id);
            const selectedPhoto =
                this.state.selectedPhoto && this.state.selectedPhoto.id === photo.id
                    ? (photos.length > 0 ? photos[0] : null)
                    : this.state.selectedPhoto;

            this.setState({
                photos: photos,
                selectedPhoto: selectedPhoto
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ error: "Не удалось удалить фотографию" });
        });
    }

    async downloadAllPhotos() {
        if (!this.state.eventid) {
            this.setState({ error: "Не задано событие" });
            return;
        }

        this.setState({ error: null });

        try {
            const response = await BaseApi.get("/event/photos/archive", {
                headers: this.authHeaders(),
                params: { eventid: this.state.eventid },
                withCredentials: true,
                responseType: "blob"
            });

            const blob = new Blob([response.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `event-photos-${this.state.eventid}.zip`;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
            this.setState({ error: "Не удалось скачать архив фотографий" });
        }
    }

    async createMobileUploadLink() {
        if (!this.state.eventid) {
            this.setState({ error: "Не задано событие" });
            return;
        }

        this.setState({
            mobileUploadLoading: true,
            mobileUploadCopied: false,
            error: null
        });

        try {
            const response = await BaseApi.post("/event/photos/mobile-upload-token", null, {
                headers: this.authHeaders(),
                params: { eventid: this.state.eventid },
                withCredentials: true
            });


            const relativeUrl = response.data.result.url        

            const mobileUploadUrl = relativeUrl.startsWith("http")
                ? relativeUrl
                : `${window.location.origin}${relativeUrl}`;

            this.setState({
                mobileUploadUrl,
                mobileUploadLoading: false
            });

            if (navigator.clipboard) {
                await navigator.clipboard.writeText(mobileUploadUrl);
                this.setState({ mobileUploadCopied: true });
            }

        } catch (error) {
            console.log(error);
            this.setState({
                mobileUploadLoading: false,
                error: "Не удалось создать ссылку для загрузки с телефона"
            });
        }
    }

    renderUploadZone() {
        return (
            <div
                className={
                    "border rounded p-3 mb-3 text-center " +
                    (this.state.dragOver ? "border-primary bg-light" : "border-secondary")
                }
                onDragOver={(e) => {
                    e.preventDefault();
                    this.setState({ dragOver: true });
                }}
                onDragLeave={(e) => {
                    e.preventDefault();
                    this.setState({ dragOver: false });
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    this.setState({ dragOver: false });
                    this.handleFiles(e.dataTransfer.files);
                }}
            >
                <input
                    ref={this.fileInputRef}
                    type="file"
                    accept="image/jpeg"
                    multiple
                    className="d-none"
                    onChange={this.handleFileInput}
                />

                <div className="mb-2">
                    Перетащите JPEG-фотографии сюда
                </div>

                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={this.openFileDialog}
                    disabled={this.state.uploading}
                >
                    Выбрать фотографии
                </button>

                {this.state.uploading && (
                    <div className="mt-2 text-muted">
                        Загрузка...
                    </div>
                )}
            </div>
        );
    }

    render() {
        const selected = this.state.selectedPhoto;

        return (
            <div className="container">
                <ScreenCaption
                    goback={this.props.goback}
                    args={this.props.args}
                    caption={"Фотоотчёт"}
                />

                <div className="row mt-4">
                    <div className="col-12">
                        {this.renderUploadZone()}

                        <div className="d-flex justify-content-end mb-3">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={this.downloadAllPhotos}
                                disabled={this.state.loading || this.state.photos.length === 0}
                            >
                                Скачать все фото
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={this.createMobileUploadLink}
                                disabled={this.state.mobileUploadLoading}
                            >
                                {this.state.mobileUploadLoading
                                    ? "Создание ссылки..."
                                    : "Ссылка для загрузки с телефона"}
                            </button>
                        </div>

                        {this.state.mobileUploadUrl && (
                            <div className="alert alert-info">
                                <div className="mb-2">
                                    Ссылка для загрузки фото с телефона:
                                </div>

                                <a
                                    href={this.state.mobileUploadUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        overflowWrap: "anywhere"
                                    }}
                                >
                                    {this.state.mobileUploadUrl}
                                </a>

                                {this.state.mobileUploadCopied && (
                                    <div className="small text-muted mt-2">
                                        Ссылка скопирована в буфер обмена
                                    </div>
                                )}
                            </div>
                        )}

                        

                        {this.state.error && (
                            <div className="alert alert-danger">
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </div>

                {this.state.loading && (
                    <div className="text-muted">
                        Загрузка фотографий...
                    </div>
                )}

                {!this.state.loading && this.state.photos.length === 0 && (
                    <div className="card shadow-sm">
                        <div className="card-body text-muted">
                            Фотографии пока не загружены.
                        </div>
                    </div>
                )}

                {!this.state.loading && this.state.photos.length > 0 && (
                    <div className="row">
                        <div className="col-lg-9 mb-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    {selected && (
                                        <div>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="text-muted small">
                                                    {selected.originalName || selected.name || "Фото"}
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => this.deletePhoto(selected)}
                                                >
                                                    <img
                                                        src={del}
                                                        alt=""
                                                        style={{ width: "16px", height: "16px", marginRight: "6px" }}
                                                    />
                                                    Удалить
                                                </button>
                                            </div>

                                            <img
                                                src={API_BASE_URL+selected.url}
                                                alt={selected.originalName || "Фото события"}
                                                className="img-fluid rounded"
                                                style={{
                                                    width: "100%",
                                                    maxHeight: "70vh",
                                                    objectFit: "contain",
                                                    background: "#f8f9fa"
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div
                                className="card shadow-sm"
                                style={{
                                    maxHeight: "75vh",
                                    overflowY: "auto"
                                }}
                            >
                                <div className="card-body">
                                    <h6 className="card-title mb-3">
                                        Фотографии
                                    </h6>

                                    {this.state.photos.map(photo => {
                                        const active =
                                            this.state.selectedPhoto &&
                                            this.state.selectedPhoto.id === photo.id;

                                        return (
                                            <button
                                                key={photo.id}
                                                type="button"
                                                className={
                                                    "btn p-1 mb-2 w-100 " +
                                                    (active ? "border border-primary" : "border")
                                                }
                                                onClick={() => this.setState({ selectedPhoto: photo })}
                                            >
                                                <img
                                                    src={photo.thumbnailUrl || photo.url}
                                                    alt={photo.originalName || "Фото"}
                                                    className="img-fluid rounded"
                                                    style={{
                                                        width: "100%",
                                                        height: "90px",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event-gallery.js